import { TSTitleCard } from '@/components/shared/card/Card';
import { useLocationGroups } from '@/services/location/useLocationGroups';
import { FunctionComponent, useState } from 'react';
import { FiHome } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import adminStrings from '../admin.translations';
import AdminAddLocationModal from './AdminAddLocationModal';
import AdminLocationTable from './AdminLocationTable';

const AdminLocationsSection: FunctionComponent = () => {
  const groups = useLocationGroups();
  const [addLocationModalOpen, setAddLocationModalOpen] = useState(false);

  const navigate = useNavigate();

  const onLocationEdit = (id: number) => {
    navigate(`${id}`);
  };

  return (
    <>
      <TSTitleCard
        title={adminStrings.locationsSection.title}
        icon={FiHome}
        className="w-full"
        primaryAction={{
          label: adminStrings.locationsSection.table.addNew,
          onClick: () => {
            setAddLocationModalOpen(true);
          },
          icon: 'add'
        }}
      >
        <AdminLocationTable groups={groups} onEdit={onLocationEdit} />
      </TSTitleCard>
      <AdminAddLocationModal
        open={addLocationModalOpen}
        onClose={() => {
          setAddLocationModalOpen(false);
        }}
      />
    </>
  );
};

export default AdminLocationsSection;
